<template lang="pug">
.item-public-member
  .item-top-board
    .board-img
      img.img(:src="require('../../assets/Obee_Logo_140@2x.png')" v-if="item.icon === '' || item.icon === null")
      img.img(:src="item.icon" v-else)
    .board-info
      span {{item.name}}
    .borard-check
      .item-checkbox
        input(type="checkbox" :checked="item.checked" :value="item.id" :id="'public_popup_' + item.id"  @click="onClickToggle(item.id, $event)")
        label(:for="'public_popup_' + item.id")
      span Tham gia cộng đồng
  .box-toggle-public(:class="[checkedToggle ? 'open-toggle' : '']")
    .item-middle-board
      span Chọn vai trò
      select(@change="changeStatus(item.id, $event)")
        option( value='1' :selected="status === 1") Học sinh
        option( value='2' :selected="status === 2") Trợ lý
    .item-bottom-board(v-if="item.classes && item.classes.length > 0")
      .classes-item(v-for="(item1, index1) in item.classes")
        .classes-item-info
            img.img(:src="require('../../assets/images/theory/lock.svg')" v-if="item1.private")
            span {{item1.name}}
        .classes-item-check
            .item-checkbox
              input(type="checkbox" name="class_popup" :checked="isChecked(item1.id)" :value="item1.id" :id="'class_popup_' + item1.id"  @click="onClickChecked(item.id, item1, $event)")
              label(:for="'class_popup_' + item1.id")
            span Tham gia
</template>

<script>
import MdNotification from '@/core/components/mdNotification'

export default {
  components: {
    MdNotification
  },
  props: {
    item: Object
  },
  data() {
    return {
      checkedToggle: false,
      status: 1,
      lstClasses: []
    }
  },
  mounted () {
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    isChecked(classID) {
      var dataReturn = this.lstClasses.filter(a => a.id === classID)
      return Object.entries(dataReturn).length > 0
    },
    onClickToggle(pcID, event) {
      this.checkedToggle = event.target.checked
      this.item.checked = this.checkedToggle
      if (!this.checkedToggle) this.lstClasses = []
      this.$emit('onClickChecked', pcID, this.status, this.checkedToggle, this.lstClasses)
    },
    changeStatus(pcID, event) {
      this.status = Number(event.target.value)
      this.$emit('onClickChecked', pcID, this.status, this.checkedToggle, this.lstClasses)
    },
    onClickChecked(pcID, item, event) {
      var id = Number(event.target.value)
      if (event.target.checked) this.lstClasses.push({id: item.id, private: item.private, type_approval: item.type_approval, exercise_ids: item.exercise_ids})
      else this.lstClasses = this.lstClasses.filter(classes => classes.id !== id)
      this.$emit('onClickChecked', pcID, this.status, this.checkedToggle, this.lstClasses)
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  created () {
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.box-public-member{
  .title-note{margin-bottom: 16px;}
  .item-public-member{padding: 15px; border-radius: 10px; background: #fff; margin-bottom: 16px;box-shadow: 0px 1px 2px #00000029;
    .item-checkbox{display:inline-flex; width: 30px;justify-content: center;align-items: center;
      input{display:none;}
      input + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box_outline@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block; background-size: cover; margin: 0;}
      input:checked + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box@2x.png") no-repeat center center;height: 20px;width: 20px;display:inline-block;background-size: cover;}
    }
    .item-top-board{display: flex;justify-content: center; align-items: center;
      .board-img{width: 16px; height: 16px; margin: 0 auto; border-radius: 50%; display: inline-flex;overflow: hidden; justify-content: center;
        img{max-width: 100%; height: auto; object-fit: cover;}
      }
      .board-info{ width: calc(100% - 200px); display: inline-flex; margin-left: 8px;
        span{font-size: 15px; font-weight: bold; display: block;}
      }
      .borard-check{display: inline-flex; width: 170px;
        span {color: #333333; font-size: 15px;}
      }
    }
    .box-toggle-public{display: none;
      &.open-toggle{display: block;}
      .item-middle-board{color: #333333; font-size: 15px; margin-bottom: 17px; margin-top: 12px;
        select{margin-left: 24px; height: 32px; background: #FBF4D2 0% 0% no-repeat padding-box; border-radius: 10px; padding: 0 5px; border: 0 none;color: #4B2D15; font-size: 12px; min-width: 132px;}
      }
      .item-bottom-board{
        .classes-item{border-top: 1px solid #F2F2F2; padding: 10px;
          &:last-child{padding-bottom: 0;}
          .classes-item-info{display: inline-flex; width: calc(100% - 90px);vertical-align: text-bottom;
            img{width: 13px;}
            span{margin-left: 5px; color: #333333; font-size: 15px; font-weight: normal;}
          }
          .classes-item-check{display: inline-flex; width: 90px;}
        }
      }
    }
  }
}
@media (max-width: 991px){
  .member-form{
    .box-content{
      .box-public-member{
        .item-public-member{
          .item-top-board {
            .board-info{width: calc(100% - 30px);}
            .borard-check{width: 30px;
              span{display: none;}
            }
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// templateItem.vue?5ecf729a